export default __webpack_public_path__ + "static/media/onboarding-info-1.51cba483.png";